import Vue from 'vue'
import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar'
import animations from './animations'
import { getDevice, isTouchDevice } from './utils'
import store from '../store'

class Smooth {
  constructor() {
    this.scrollbar = null

    this.bg = false
  }

  initScrollbar() {
    return new Promise((resolve) => {
      if (this.scrollbar) {
        resolve()
        return
      }

      class BlockPlugin extends ScrollbarPlugin {
        static pluginName = 'blockScroll';

        static defaultOptions = {
          blocked: true,
        };

        transformDelta(delta) {
          return this.options.blocked ? { x: 0, y: 0 } : delta;
        }
      }

      class DisableScrollPlugin extends ScrollbarPlugin {
        static pluginName = 'BolockPlugin';

        static defaultOptions = {
          direction: 'x'
        };

        transformDelta(delta) {
          if (this.options.direction) {
            delta[this.options.direction] = 0 // eslint-disable-line
          }
          return { ...delta }
        }
      }
      Scrollbar.use(DisableScrollPlugin, BlockPlugin)

      const section = document.querySelector('#smoothie')

      const damping = isTouchDevice() ? 0.1 : 0.7;

      this.scrollbar = Scrollbar.init(section, { damping, syncCallbacks: true })
      store.dispatch('SET_SMOOTH', this.scrollbar)

      resolve()
    })
  }

  destroyScrollbar() {
    return new Promise((resolve) => {
      if (!this.scrollbar) resolve()

      this.scrollbar.destroy()
      this.scrollbar = null
      store.dispatch('SET_SMOOTH', null)
      resolve()
    })
  }

  getScrollbar() {
    return this.scrollbar
  }

  listenScroll() {
    this.animateEls = Array.from(this.scrollbar.containerEl.querySelectorAll('[data-anim]'))
    this.videos = Array.from(this.scrollbar.containerEl.querySelectorAll('[data-video]'))
    let current = 0
    let direction

    this.scrollbar.addListener((status) => {
      if (status.offset.y < current) {
        direction = 'up'
      } else {
        direction = 'down'
      }

      if (current > window.innerHeight * 0.5 && !document.body.hasAttribute('data-animated')) {
        this.bg = true
        animations.get('bg')('#000000', true)
      } else if (this.bg && current <= window.innerHeight * 0.5) {
        this.bg = false
        animations.get('bg')('#101010', false)
      }

      current = status.offset.y
      window.scrollTop = current
      if (this.customScrollbar) this.customScrollbar(status, direction)

      this.animateEls.forEach((el, i) => {
        if (getDevice() === 'xs' && el.getAttribute('data-anim') === 'parallax') return

        if (this.scrollbar.isVisible(el) && el.getAttribute('data-anim') === 'parallax') {
          animations.get('parallax')(el, i)
        } else if (this.scrollbar.isVisible(el) && !el.hasAttribute('data-animated')) {
          el.setAttribute('data-animated', '')

          const type = el.getAttribute('data-anim')
          animations.get(type)(el)
        }
      })
    })
  }

  scrollTo(y, time) {
    this.scrollbar.scrollTo(0, y, time)
  }
}

const smooth = new Smooth()
export default function install() {
  Vue.prototype.$smooth = smooth

  Vue.mixin({
    beforeCreate() {
      this.$options.scrollbar = smooth.scrollbar
    },

    created() {
      const options = this.$options

      // store injection
      if (options.scrollbar) {
        this.$scrollbar = typeof options.scrollbar === 'function'
          ? options.scrollbar : smooth.scrollbar
      } else if (options.parent && options.parent.$scrollbar) {
        this.$scrollbar = options.parent.$scrollbar
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/scripts/scrollbar.js